@switch (columnName) {
  @case ('from') {
    {{ element.from | date: dateTimeFormat }}
  }
  @case ('to') {
    {{ element.to | date: dateTimeFormat }}
  }
  @case ('phone') {
    {{ element.mobilePrefix }}{{ element.mobile }}
  }
  @case ('nextOfKin') {
    {{ element.nextOfKin?.name }}
  }
  @case ('nextOfKinPhone') {
    {{ element.nextOfKin?.phoneNumber }}
  }
  @case ('fullName') {
    <div class="display-flex align-items-center">
      @if (!element.isDisabled) {
        <app-ui-navigate-to-person
          [id]="element.paxId"
          type="pax"
          buttonClass="m-0 small-icon"
          iconVariant="legacy"
        ></app-ui-navigate-to-person>
        @if (element.fullName) {
          {{ element.fullName }}
        } @else {
          {{ element.firstName }} {{ element.lastName }}
        }
      } @else {
        <div class="split-activity-cell divider-bottom"></div>
      }
    </div>
  }
  @case ('name') {
    {{ element.firstName }} {{ element.lastName }}
  }
  @case ('edit') {
    @if (!element.isDisabled) {
      <app-ui-button
        class="small-icon"
        buttonType="icon-button"
        iconVariant="legacy"
        icon="edit"
        (click)="editPax(element)"
        [privilege]="Privileges.TripPaxUpdate"
      ></app-ui-button>
    }
  }
  @case ('delete') {
    @if (!element.isDisabled) {
      <app-ui-button
        class="small-icon"
        buttonType="icon-button"
        iconVariant="legacy"
        icon="delete"
        appConfirmDialog
        confirmTitle="removePassengers"
        [content]="content"
        (confirmed)="deletePax(element)"
        [privilege]="Privileges.TripPaxDelete"
      ></app-ui-button>
    }
    <ng-template #content>
      <p class="error">
        {{ 'tripCrewRemoveWarning' | translate }}
      </p>
    </ng-template>
  }
  @default {
    {{ element[columnName] }}
  }
}
